module.exports = __webpack_public_path__ + "static/img/tt-4.487c10a.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/image/tt-4.jpg
 ** module id = 591
 ** module chunks = 2
 **/